/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import DataTableFilter from "../../Common/DataTableFilter";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector,useDispatch } from "react-redux";
import { COURIERS_URL } from "../../Shared/constant";
import { useNavigate } from "react-router-dom";
import { ClearFormSetFutios } from "../../../redux/actions/adminActions";
import CommonTable from "../../Common/CommonTable";

const CouriersListPage = (props) => {
    const navigate = useNavigate();
    const Dispatch = useDispatch();
    const [ userSearch, setUserSearch ] = useState("");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const { websocket } = useContext(WebSocketContext);
    const [ userType, setUserType ] = useState("");
    const { device_id, CourierList, selfInfo } = useSelector((state) => state.adminReducers);
    const PermissionsAccess = selfInfo?.user?.permissions_access;

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };

    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Masters[4]?.Edit || PermissionsAccess?.Masters[4]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "courier_list",
                "request" : { 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "search" : userSearch.trim(),
                    "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                    "order_by" :"-updated_at"
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        }
    }, [ websocket, userSearch, currentPage, userType, userLimit ]);


    // create Couriers
    const cmnFnct = () => {
        navigate(`${COURIERS_URL}/add`)
    };

    useEffect(() => {
        Dispatch(ClearFormSetFutios({
            url:"",
            action:false
        }));
    }, []);

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'courier_name', label: 'Courier Name', type: "label", sort: "", isCollapsable: false },
        { key: 'gst_no', label: 'GST', type: "label", sort: "", isCollapsable: false },
        { key: 'vehicle_no', label: 'Vehicle No.', type: "label", sort: "", isCollapsable: false },
        { key: 'tracking_link', label: 'Tracking Link', type: "label", sort: "", isCollapsable: false },
        { key: 'slug', label: 'Slug', type: "label", sort: "", isCollapsable: false },
        { key: 'remarks', label: 'Remarks', type: "label", sort: "", isCollapsable: false },
        { key: 'is_tracking_by_docket', label: 'Docket Number / EWB Number', type: "status_Docket_EWB", sort: "", isCollapsable: false },
        { key: 'is_active', label: 'Status', type: "status_active", sort: "", isCollapsable: false },
    ];

    return(<section className="Main_section">
        <DataTableFilter 
            filterType={"Courier"}
            searchType={"Courier Name"}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            SelectUserTypeFnct={SelectUserTypeFnct}
            setUserType={setUserType}
            userType={userType}
            searchdisable={true}
            buttonvisible={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.Masters[4]?.Edit) ? true : false}
            ButtonSet={{
                buttontitle:"Create Couriers", 
                function: cmnFnct,
            }}
            ActiveInactiveFilter={true}
        />
        {/* COMMON TABLE */}
        <CommonTable 
            isTableAllow={true}
            style={{ height: CourierList?.pagination?.total_records > 10 ? "calc(100vh - 175px)" : "calc(100vh - 139px)"}} 
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={false}
            tabName={""} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={CourierList} // COURIERS LIST
            Pagination={CourierList?.pagination} // CURRENT TAB PAGINATION
            EditAccess={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.Masters[4]?.Edit)} // EDITABLE ACCESS STATE
            isActionColumnAvailable={{
                isShow: selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.Masters[4]?.Edit,
                label: "edit",
                naviagte: `${COURIERS_URL}/`
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>)
}

export default CouriersListPage;